import React, { useState } from 'react';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { AppServiceToken } from '../../models/app.service.model';
import { Invitation } from '../../models/invitation.model';
import { modalShow, modalHide } from '../../utils/modal.util';
import { imageCompany } from '../../scripts/image.value.script';

import AppModalInvitationView from './ModalInvitationView';
import AppLoading from '../Loading';
import EmptyState from '../element/EmptyState';
import background from '../../assets/themes/images/search.svg';

export interface AppModalInvitationListProps {
  appServiceForUser: AppServiceToken | null,
  invitations: Invitation[] | null,
  loadInvitations: Function,
  reloadSession: Function
};

const AppModalInvitationList: React.FunctionComponent<AppModalInvitationListProps> = ({appServiceForUser, invitations, loadInvitations, reloadSession}) => {
  const {lang} = StateLanguage()

  const [invitation, setInvitation] = useState<Invitation | null>(null)

  const executeSelectInvitation = (item: Invitation) => {
    setInvitation(item)
    modalHide('modal-invitation-list')
    modalShow('modal-invitation-view')
  }

  const executeHideModalInvitationWelcome = () => {
    modalHide('modal-invitation-list')
  }

  return (
    <>
      <div id="modal-invitation-list" className="modal fade" tabIndex={-1} aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div className="modal-dialog  modal-md">
          <div className="modal-content">
            <div className="modal-header pb-0 border-0 justify-content-end">
              <button className="btn btn-sm btn-icon btn-active-color-primary" type="button" onClick={executeHideModalInvitationWelcome}>
                <span className="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black" />
                  </svg>
                </span>
              </button>
            </div>
            <div className="modal-body pt-0">
              <div className="text-center mb-5">
                <h2 className="text-capitalize">{lang.labels.companyInvitations}</h2>
                <div className="text-justify">
                  {lang.labels.notificationsAboutInvitationsToSubscribe}
                </div>
              </div>
              <div className="scroll-y p-2 mh-300px border-top border-bottom">
                { invitations
                  ?
                  <>
                    { invitations.length > 0
                      ?
                      <>
                        { invitations.map (( (item, index) => { return (
                          <div key={index} className={`d-flex flex-stack py-3 cursor-pointer ${(index < invitations.length - 1) && "border-bottom border-gray-300 border-bottom-dashed"}`} onClick={() => executeSelectInvitation(item)}>
                            <div className="d-flex align-items-center">
                              <div className="symbol symbol-50px bg-light">
                                <img src={imageCompany(item.company_id?.logo)} alt={lang.labels.logo} />
                              </div>
                              <div className="ms-3">
                                <div className="fw-bold text-dark">{item.company_id?.name || ''}</div>
                                <small className="fw-semibold text-muted"></small>
                              </div>
                            </div>
                            <div className="ms-5 w-150px text-end">
                              <span className="badge badge-light py-2 text-wrap">{item.invited_by?.first_name || ''} {item.invited_by?.last_name || ''}</span>
                            </div>
                          </div>
                        )}))}
                      </>
                      :
                      <EmptyState illustration={background} illustrationAlt="" title={lang.labels.noInvitations} description={lang.labels.invitationsHaveNotReceived} size="sm" />
                    }
                  </>
                  :
                  <AppLoading></AppLoading>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <AppModalInvitationView appServiceForUser={appServiceForUser} companyForUser={null} invitation={invitation} loadInvitations={loadInvitations} reloadSession={reloadSession}></AppModalInvitationView>
    </>
  )
}

export default AppModalInvitationList;
